import React from 'react';
import {Navigate} from 'react-router-dom';

import {MyAppointmentsEnum} from 'presentation/constants';

import {MyAppointmentDetailsContent} from './components/MyAppointmentDetailsContent';
import {MyAppointmentDetailsError} from './components/MyAppointmentDetailsError';
import {MyAppointmentDetailsLoading} from './components/MyAppointmentDetailsLoading';
import {useMyAppointmentsDetails} from './hooks/useMyAppointmentsDetails';
import {MyAppointmentDetailsProps} from './types';

export function MyAppointmentDetails({flowType}: MyAppointmentDetailsProps) {
	const {
		confirmedBookAppointment,
		appointmentsListLoading,
		appointmentsListError,
		shouldRedirect,
	} = useMyAppointmentsDetails();

	if (appointmentsListLoading) {
		return <MyAppointmentDetailsLoading />;
	}

	if (appointmentsListError) {
		return <MyAppointmentDetailsError />;
	}

	if (shouldRedirect) {
		return <Navigate to={MyAppointmentsEnum.MY_APPOINTMENTS} />;
	}

	return (
		<MyAppointmentDetailsContent
			flowType={flowType}
			bookedAppointment={confirmedBookAppointment!}
		/>
	);
}
